import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { SectionTitle } from './SectionTitle';
import { CTAButton } from './CTAButton';
import { OFFER_ANCHOR, previewImages } from '../data/salesCopy';
export function PreviewSection() {
  const trackRef = useRef<HTMLUListElement>(null);
  const [active, setActive] = useState(0);
  const scrollTo = useCallback((index: number) => {
    const track = trackRef.current;
    if (!track) return;
    const slide = track.children[index] as HTMLElement | undefined;
    if (slide) {
      track.scrollTo({
        left: slide.offsetLeft,
        behavior: 'smooth'
      });
    }
  }, []);
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const onScroll = () => {
      const width = track.clientWidth || 1;
      setActive(Math.round(track.scrollLeft / width));
    };
    track.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => track.removeEventListener('scroll', onScroll);
  }, []);
  const go = (dir: -1 | 1) => {
    const next = Math.min(previewImages.length - 1, Math.max(0, active + dir));
    setActive(next);
    scrollTo(next);
  };
  return <section className="bg-brand-sand px-4 py-8 sm:py-10" data-id="element-124" data-mp="2lsxux11suax7">
      <div className="mx-auto max-w-4xl" data-id="element-125" data-mp="2lqbmz0azxteg">
        <SectionTitle data-id="element-126" data-mp="2gtcsuhrc1mg9">Aperçu du matériel</SectionTitle>
        <p className="mt-3 text-center font-serif text-xl font-bold text-brand-brown sm:text-2xl" data-id="element-127" data-mp="2grs2l4c1wpo7">
          Découvrez l’intérieur de YIN YOGA PRO™
        </p>
        <p className="mx-auto mt-1.5 max-w-2xl text-center text-[12.5px] font-medium leading-snug text-brand-brown/85 sm:text-sm" data-id="element-128" data-mp="1p3q69k5vvlp2">
          Explorez les postures visuelles, séquences structurées, variations,
          adaptations, ressources thématiques, modèles de préparation et outils
          prêts à utiliser inclus dans le système complet.
        </p>

        <div className="relative mt-4" data-id="element-129" data-mp="15ephpx2x5dy8">
          <ul ref={trackRef} className="no-scrollbar flex snap-x snap-mandatory gap-3 overflow-x-auto scroll-smooth" data-id="element-130" data-mp="15do53o698jee">
            {previewImages.map(img => <li key={img.src} className="w-full shrink-0 snap-start" data-id="element-131" data-mp="3aeh3rjz64bte">
                <a href={OFFER_ANCHOR} className="block" data-id="element-132" data-mp="3f7a846qq5i4y">
                  <img src={img.src} alt={img.alt} loading="lazy" className="w-full rounded-lg border border-brand-taupe/30 bg-white shadow-[0_10px_26px_-14px_rgba(64,54,47,0.6)]" data-id="element-133" data-mp="3k5v41tyy1fnl" />
                </a>
              </li>)}
          </ul>

          <button type="button" onClick={() => go(-1)} disabled={active === 0} aria-label="Image précédente" className="absolute left-1 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-brand-taupe/30 bg-white/95 text-brand-brown shadow-md transition-opacity duration-150 ease-smooth disabled:opacity-30" data-id="element-134" data-mp="2wi3psktuesjo">
            <ChevronLeftIcon className="h-5 w-5" data-id="element-135" data-mp="1w7syiiq9ek7e" />
          </button>
          <button type="button" onClick={() => go(1)} disabled={active === previewImages.length - 1} aria-label="Image suivante" className="absolute right-1 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-brand-taupe/30 bg-white/95 text-brand-brown shadow-md transition-opacity duration-150 ease-smooth disabled:opacity-30" data-id="element-136" data-mp="1w8m2xd1qwxmd">
            <ChevronRightIcon className="h-5 w-5" data-id="element-137" data-mp="18hq5o0eita7q" />
          </button>
        </div>

        <div className="mt-3 flex items-center justify-center gap-2" data-id="element-138" data-mp="13j5705ex2yle">
          {previewImages.map((img, i) => <button key={img.src} type="button" onClick={() => {
          setActive(i);
          scrollTo(i);
        }} aria-label={`Voir l’image ${i + 1} sur ${previewImages.length}`} aria-current={i === active} className={`h-2 rounded-full transition-[width,background-color] duration-150 ease-smooth ${i === active ? 'w-6 bg-brand-brown' : 'w-2 bg-brand-taupe/50'}`} data-id="element-139" data-mp="32wssfqc6qe6y" data-mpi={i} />)}
        </div>

        <div className="mt-4 flex justify-center" data-id="element-140" data-mp="1bvrebm10cgl9">
          <CTAButton data-id="element-141" data-mp="1buziqb7euiuz">🧘 Oui ! Je veux le système complet</CTAButton>
        </div>
      </div>
    </section>;
}